export enum BulkActionType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE'
}
